<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox">
            <div class="item">
              <el-form-item label="地址类型 :" prop="addressType">
              <el-select  v-model="searchFrom.addressType"  placeholder="请选择">
                <el-option v-for="val in types" :label="val.name" :value="val.id" :key="val.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="名称:" prop="addressName">
              <el-input  placeholder="" v-model="searchFrom.addressName"></el-input>
            </el-form-item>
             <el-form-item label="企业名称:" prop="company">
              <el-input  placeholder="" v-model="searchFrom.company"></el-input>
            </el-form-item>
            <el-form-item label="创建人:" prop="createUserName">
              <el-input  placeholder="" v-model="searchFrom.createUserName"></el-input>
            </el-form-item>
            <el-form-item label="创建时间:" prop="createTime">
                <el-date-picker
                  v-model="searchFrom.createTime"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </div>
        </div>
       <div class="searchBtnBox">
         <el-form-item>
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item btnCode="00KP003B001"  v-if="btnFlg[0]"  >
            <el-button type="primary"  @click="addRegion">新增</el-button>
          </el-form-item>
          <el-form-item btnCode="00KP003B002"  v-if="btnFlg[1]" >
            <el-button type="primary" @click="delDeiver">删除</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作"  width="55">
            <template slot-scope="scope">
              <el-button type="text" size="mini" btnCode="00KP003B003"  v-if="btnFlg[2]"   @click="modifyRegion(scope.row)">修改</el-button>
            </template>
        </el-table-column>
        <el-table-column prop="addressName" min-width="160"  :formatter="emptyFn" label="名称"></el-table-column>
         <el-table-column property="addressType" width="120" label="地址类型" >
          <template scope="scope">
            {{[ "仓库地址", "码头地址","汽运地址" ][scope.row.addressType-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="company" min-width="260" :formatter="emptyFn" label="企业名称"></el-table-column>
        <el-table-column prop="person"  min-width="120" :formatter="emptyFn" label="联系人"></el-table-column>
        <el-table-column prop="phone" width="170" :formatter="emptyFn" label="联系电话"></el-table-column>
         <el-table-column property="type" min-width="350" label="地址" >
          <template scope="scope">
            {{scope.row.provinceName+scope.row.cityName+scope.row.areaName+scope.row.address}}
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" width="120" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新建修改 -->
    <el-dialog  :title="title"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog"   :visible.sync="dialogVisible" width="1100px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class="inpBox">
               <el-form-item label="地址类型:" class="jiage" prop="addressType">
                <el-select  v-model="addFrom.addressType"    placeholder="请选择">
                  <el-option v-for="item in types" :label="item.name" :value="item.id" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
               <el-form-item :label="addFrom.addressType==3?'地址名称':addFrom.addressType==2?'码头名称':'仓库名称'" prop="addressName">
                <el-input  placeholder="" maxlength="20"  v-model="addFrom.addressName"></el-input>
              </el-form-item>
               <el-form-item label="企业名称:" prop="company" :rules="addFrom.addressType == 1? rules.shipNo:[{required: false}]">
                <el-input  placeholder="" maxlength="20"  v-model="addFrom.company"></el-input>
              </el-form-item>
              <el-form-item label="联系人:" prop="person" :rules="addFrom.addressType == 1? rules.shipNo:[{required: false}]">
                <el-input  placeholder="" maxlength="10"  v-model="addFrom.person"></el-input>
              </el-form-item>
               <el-form-item label="联系电话:" prop="phone" :rules="addFrom.addressType == 1? rules.shipNo:[{required: false}]">
                <el-input  placeholder="" maxlength="11"  type="tel" v-model="addFrom.phone"></el-input>
              </el-form-item>
              <hr>
              <mapAddress :addFrom="addFrom"  v-if="flag"></mapAddress>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { sAddressList, sAddressAdd, sAddressUpdate, sAddressDelete } from '@/api/shipping'
import { emptyFn, dateTimeFormat } from '@/utils/util'
import mapAddress from '@/components/common/mapAddress.vue'
export default {
  components: {
    mapAddress
  },
  data () {
    return {
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      title: '新建',
      dialogVisible: false,
      checkList: [],
      tableList: [],
      types: [
        { name: '请选择', id: '' },
        { name: '仓库地址', id: 1 },
        { name: '码头地址', id: 2 }
        // { name: '汽运地址', id: 3 }
      ],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      ids: [],
      loading: 'false',
      rules: {
        addressName: [
          { required: true, message: '请输入地址名称', trigger: 'blur' }
        ],
        company: [
          { required: true, message: '请输入单位名称', trigger: 'blur' }
        ],
        person: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        addressType: [
          { required: true, message: '请选择地址类型', trigger: 'blur' }
        ],
        mapShengShiQu: [
          { required: true, message: '请在地图上选择地址', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请在地图上选择地址', trigger: 'blur' }
        ]
      },
      addFrom: {},
      flag: true, // 控制组件
      btnFlg: [],
      btnIdArr: ['00KP003B001', '00KP003B002', '00KP003B003']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/basicData/address')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      sAddressList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 添加
    addRegion () {
      this.title = '新建'
      this.addFrom = {}
      this.dialogVisible = true
      this.isAdd = true
      this.flag = true
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    },
    // 修改
    modifyRegion (row) {
      this.addFrom = JSON.parse(JSON.stringify(row))
      // if (row.cityName && !row.areaName) {
      //   this.$set(this.addFrom, 'areaCode1', [row.provinceCode, row.cityCode])
      // } else if (!row.cityName && !row.areaName) {
      //   this.$set(this.addFrom, 'areaCode1', [row.provinceCode])
      // } else {
      //   this.$set(this.addFrom, 'areaCode1', [row.provinceCode, row.cityCode, row.areaCode])
      // }
      this.title = '修改'
      this.dialogVisible = true
      this.isAdd = false
      this.flag = true
    },
    saveFn (formName) {
      this.addFrom.isDefault = 1
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            sAddressAdd(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            sAddressUpdate(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                duration: 0,
                onClose () {
                  loading.close()
                }
              })
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除
    delDeiver () {
      const selectData = this.$refs.table.selection
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
      } else {
        this.$confirm('是否执行删除操作?', '系统提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          sAddressDelete({ id: selectData[0].id }).then(res => {
            loading.close()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(() => {

        })
      }
    },
    closeDialog () {
      this.addFrom = {}
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.flag = false
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = '-'
      } else {
        str =
          t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}

</style>
